import { useEffect, useState } from 'react';

export const useUpgradeTagLimit = (
  ref: React.RefObject<HTMLElement>,
  averageTagWidth: number,
  tagPadding: number,
): number => {
  const [tagLimit, setTagLimit] = useState<number>(2);

  useEffect(() => {
    const updateTagLimit = () => {
      if (ref.current) {
        const width = ref.current.clientWidth;

        const limit = Math.max(Math.floor(width / (averageTagWidth + tagPadding)), 1);
        setTagLimit(limit - 1);
      }
    };

    updateTagLimit();

    window.addEventListener('resize', updateTagLimit);
    return () => {
      window.removeEventListener('resize', updateTagLimit);
    };
  }, [ref, averageTagWidth, tagPadding]);

  return tagLimit;
};
